import i from "./ghl-ui.es703.js";
import e from "./ghl-ui.es1018.js";
import f from "./ghl-ui.es1198.js";
import n from "./ghl-ui.es1199.js";
import a from "./ghl-ui.es1200.js";
import p from "./ghl-ui.es1197.js";
import s from "./ghl-ui.es1201.js";
var u = 1, A = 2;
function y(r, o) {
  return n(r) && a(o) ? p(s(r), o) : function(m) {
    var t = e(m, r);
    return t === void 0 && t === o ? f(m, r) : i(o, t, u | A);
  };
}
export {
  y as default
};
